import fetchData from '@/service/fetch'
import api from '@/service/api'
import Layout from '@/views/layout/layout'
import store from "../index";

/**
 * 递归生成菜单
 * @param {*} parentMenus 父节点
 * @param {*} exceptParentMenus 除过父节点剩下的
 */
function getMenuTree(parentMenus, exceptParentMenus) {
  for (let i = 0; i < parentMenus.length; i++) {
    parentMenus[i].childrens = []
    for (let j = exceptParentMenus.length - 1; j >= 0; j--) {
      if (exceptParentMenus[j].parentId === parentMenus[i].id * 1) {
        parentMenus[i].childrens.push(exceptParentMenus[j])
        exceptParentMenus.splice(j, 1)
      }
    }
    if (parentMenus[i].childrens.length > 0 && exceptParentMenus.length > 0) {
      getMenuTree(parentMenus[i].childrens, exceptParentMenus)
    }
  }
  return parentMenus
}

/**
 * 生成权限树结构
 * @param {*} allUserSource 所有权限
 */
function asyncRouterHandler(allUserSource) {
  const allMenus = []

  for (let s = allUserSource.length - 1; s >= 0; s--) {

    if (allUserSource[s].isMenu > 0 && allUserSource[s].isShow > 0) {
      allMenus.push(allUserSource[s])
      allUserSource.splice(s, 1)
    }

  }

  const parentMenus = []
  for (let i = allMenus.length - 1; i >= 0; i--) {
    if (allMenus[i].parentId === 0 && allMenus[i].isShow > 0) {
      parentMenus.push(allMenus[i])
      allMenus.splice(i, 1)
    }
  }
  return getMenuTree(parentMenus, allMenus)
}

const permission = {
  state: {
    allMenus: [],
    userMenus: [],
    userInfo: [],
    fwCols:{},
    resMenus:[]
  },
  mutations: {
    SET_ALL_MENUS: (state, allMenus) => {
      state.allMenus = allMenus
    },
    SET_TOTAL_MENUS: (state, totalMenus) => {
      state.totalMenus = totalMenus
    },
    SET_USER_MENUS: (state, userMenus) => {
      state.userMenus = userMenus
    },
    SET_USER_INFO:(state,userInfo)=>{
      state.userInfo = userInfo
    },
    SET_FW_COLS:(state,fwCols)=>{
      state.fwCols=fwCols
    },
    SET_RES_MENUS:(state,data)=>{
      state.resMenus=data
    }
    },
  actions: {
    async  getMenus({state, commit}, data) {
      if (state.allMenus.length === 0) {
        //获取菜单
        let result = fetchData(api.getUserPermissions).then(res => {
          let tempRes = JSON.parse(JSON.stringify(res));
          commit('SET_RES_MENUS',tempRes)
          const userMenus = asyncRouterHandler(res)
          commit('SET_ALL_MENUS', res)
          commit('SET_USER_MENUS', userMenus)
          return res
        })
        let param = {
          "page": 1,
          "pageSize": 20000,
          "orderBy": "id desc",
          "totalRows": 0,
          "export": false,
          "queryParamList": [
            { "field": "menuType", "type": "string", "logic": "=", "value": "0", "items": [] }
          ]
        }
        // 获取所有的菜单
        fetchData(api.menuList.queryPage, param, 'POST').then(res => {
          let totalMenusUrl = []
          for (let v of res.content) {
            totalMenusUrl.push(v.url)
          }
          localStorage.setItem("totalMenus", JSON.stringify(totalMenusUrl))
          return res
        })
        //获取自定义列
        store.dispatch('getFwCols').then(res => { })
        // let cols =await fetchData(api.getUserCols).then(cols => {
        //   commit('SET_FW_COLS', Object.assign({},...cols))
        //   return cols
        // })
        return result;
      }
    },
    async getFwCols({state, commit}, data){
      let cols =await fetchData(api.getUserCols).then(cols => {
        let result = Object.assign({},...cols)
        // console.log('result ----',result)
        commit('SET_FW_COLS',result)
        //55252102885098
        return cols
      })
      return cols;
    },

    getUserInfo({state,commit},data){
      fetchData(api.getUserInfo).then(res =>{
        commit('SET_USER_INFO',res)
        return res
      })
    }
  }
}

export default permission
